export default __webpack_public_path__ + "static/media/paint.849956e0.svg";